module.exports = __webpack_public_path__ + "static/media/57fbef4b-2517-45d3-ab29-53a9637d1332_1.f7a626be476de8c5c6309c89bdf57fa1.f0041783.jpeg";